<template>
  <div class="mobile-app-page">
    <img
      :src="config.appIconFile"
      :alt="config.main_name"
      class="mobile-app-page__logo"
    />

    <p
      v-if="isNdrcamera"
      class="mobile-app-page__text"
      style="font-weight: normal;"
      v-html="$t('install_mobile_application_alt')"
    ></p>

    <p v-else class="mobile-app-page__text">
      {{ $t('install_mobile_application') }}
      {{ config.main_name }}
    </p>

    <div class="mobile-app-page__links">
      <a
        v-if="config.appLinkAndroid"
        :href="config.appLinkAndroid"
        class="mobile-app-page__app-link"
      >
        <img
          :src="resolveUrl('/img/static/application/google-play-light.svg')"
          alt="Google Play"
        />
      </a>

      <a
        v-if="config.appLinkIOS"
        :href="config.appLinkIOS"
        class="mobile-app-page__app-link"
      >
        <img
          :src="resolveUrl('/img/static/application/app-store-light.svg')"
          alt="App Store"
        />
      </a>

      <a
        v-if="config.appLinkRuStore"
        :href="config.appLinkRuStore"
        class="mobile-app-page__app-link"
      >
        <img
          :src="resolveUrl('/img/static/application/ruStore.svg')"
          alt="RuStore"
        />
      </a>

      <a
        v-if="config.appLinkAppGallery"
        :href="config.appLinkAppGallery"
        class="mobile-app-page__app-link"
      >
        <img
          :src="resolveUrl('/img/static/application/app-gallery-light.svg')"
          alt="AppGallery"
        />
      </a>
    </div>
  </div>
</template>

<script type="javascript">

export default {
  name: 'MobileAppPage',

  computed: {
    platform() {
      if (this.isAndroidPhone) {
        return 'Android';
      }

      if (this.isApplePhone) {
        return 'Apple';
      }

      return null;
    },

    appLink() {
      if (this.isAndroidPhone) {
        return this.config.appLinkAndroid;
      }

      if (this.isApplePhone) {
        return this.config.appLinkIOS;
      }

      return false;
    }
  },

  mounted() {
    if (this.config?.appIconFile) {
      this.checkAppLogo();
    }
  },
}
</script>

<style lang="sass" scope>
@import '../sass/variables';
@import '../sass/mixins';

.mobile-app-page
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  padding: 46px 26px 46px

  &__logo
    width: 100%
    max-width: 128px
    overflow: hidden
    margin-bottom: 24px

    img
      width: 100%
      height: 100%
      object-fit: contain

  &__text
    +TextHeader(2)
    text-align: center
    margin-bottom: 24px
    max-width: 700px;

    strong
      white-space: nowrap

  &__button
    +Button()

  &__app-link
    display: flex
    justify-content: center
    align-items: center
    align-self: center
    padding: 10px

    &:not(:last-child)
      margin-bottom: 24px
</style>
